<template>
  <div class="relative group sm:w-60 flex-shrink-0">
    <GraduationCap
      class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-[#7E8DA5] w-4 h-4 pointer-events-none"
    />

    <select
      v-model="selectedClassId"
      class="w-full pl-10 pr-8 py-2.5 border border-slate-200 dark:border-[#263449] rounded-xl bg-slate-50 dark:bg-[#172235] text-slate-800 dark:text-[#F1F5F9] appearance-none shadow-sm focus:outline-none focus:bg-white dark:focus:bg-[#18243A] focus:border-indigo-600 focus:ring-4 focus:ring-indigo-500/10 text-sm transition"
      placeholder="Select Class"
    >
      <option
        disabled
        value=""
        class="bg-white dark:bg-[#111C30] text-slate-500"
      >
        Select Class
      </option>
      <option
        value="null"
        class="bg-white dark:bg-[#111C30] text-slate-800 dark:text-[#F1F5F9]"
      >
        All Classes
      </option>

      <option
        v-for="cls in classes.filter(
          (c) => !['passout', 'passot'].includes(c.name?.toLowerCase()),
        )"
        :key="cls._id"
        :value="cls._id"
        class="bg-white dark:bg-[#111C30] text-slate-800 dark:text-[#F1F5F9]"
      >
        {{ cls.name }}{{ cls.section ? ` - ${cls.section}` : "" }}
      </option>
    </select>

    <ChevronDown
      class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-[#7E8DA5] w-4 h-4 pointer-events-none"
    />
  </div>
</template>

<script setup>
  import { ref, computed, watch, onMounted } from "vue";
  import { useStore } from "vuex";
  import { GraduationCap, ChevronDown } from "lucide-vue-next";

  const store = useStore();

  const selectedClassId = ref("");
  const classes = computed(() => store.getters.allClasses || []);

  const emit = defineEmits(["selected-class"]);

  onMounted(async () => {
    await store.dispatch("fetchAllClasses");
  });

  /* ✅ Emit ONLY when user selects */
  watch(selectedClassId, (val) => {
    const cls = classes.value.find((c) => c._id === val) || null;
    emit("selected-class", cls);
  });
</script>
